<template>
  <b-row class="pt-2">
    <b-col :cols="12">
      <TheRoundInfoOverview :round="round" />
    </b-col>
    <b-col
      :cols="12"
      :class="$style.athletesOverviewWrapper"
      class="p-4"
    >
      <BaseLoading
        v-if="isSelectedAthletesLoading"
        :min-height="200"
      />
      <template v-else>
        <b-row class="d-flex justify-content-center">
          <b-col
            b-col
            cols="12"
            sm="11"
            md="11"
            lg="10"
          >
            <ThePickAthletes
              v-if="round.status === roundStatuses.upcoming"
              :athletes="athletes"
              :round-id="round.id"
              @onPlayerAdd="$emit('onPlayerAdd')"
              @onAthletePickRemove="$emit('onAthletePickRemove')"
            />
            <TheAthletesPerformanceOverview
              v-else
              :athletes="athletes"
            />
          </b-col>
        </b-row>
      </template>
    </b-col>

    <b-col
      v-if="!isOpenDetailButtonHidden"
      :cols="12"
      class="p-4"
    >
      <router-link :to="{ name: 'round-history', params: { roundId: round.id }}">
        <BaseButton is-rounded>
          {{ $t('see-more') }}
        </BaseButton>
      </router-link>
    </b-col>
  </b-row>
</template>

<script>
import { ROUND_STATUSES } from '@/store/modules/rounds/index'
import TheAthletesPerformanceOverview from '@/components/Molecules/TheAthletesPerformanceOverview'
import BaseButton from '@/components/Atoms/BaseButton'
import ThePickAthletes from '@/pages/RoundDetail/Components/Molecules/ThePickAthletes'
import BaseLoading from '@/components/Atoms/BaseLoading'
import TheRoundInfoOverview from '@/components/Molecules/TheRoundInfoOverview'

export default {
  name: 'TheRoundWidget',
  components: {
    TheRoundInfoOverview,
    BaseLoading,
    ThePickAthletes,
    BaseButton,
    TheAthletesPerformanceOverview,
  },
  props: {
    round: {
      type: Object,
      required: true,
    },
    isOpenDetailButtonHidden: {
      type: Boolean,
      required: false,
      default: false,
    },
    isSelectedAthletesLoading: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      roundStatuses: ROUND_STATUSES,
    }
  },
  computed: {
    athletes() {
      return this.$store.getters['rounds/athletesInRound/getSelectedAthletesForRound'](this.round.id)
    },
  },
}
</script>

<style module lang="scss">
  @import '../../assets/scss/variables';
  .athletesOverviewWrapper {
    background-color: $color-bleached-silk;
    border-bottom: 1px solid $color-jupiter;
  }
</style>
